module.exports = __webpack_public_path__ + "static/media/main4_en.4fb2a2f8.png";